/**
 * 轻量化相关
 */
export default {
  isWaiting(status) {
    return status === "1" || status === "5" || status === 1 || status === 5;
  },

  isSuccess(status) {
    return status === "2" || status === "6" || status === 2 || status === 6;
  },

  isFail(status) {
    return status === "3" || status === "7" || status === 3 || status === 7;
  },

  isDealing(status) {
    return status === "4" || status === "8" || status === 4 || status === 8;
  },
  
  setDealing(row) {
    row.status = 4
  }
}
